import { render, staticRenderFns } from "./ProductListCarouselCardHorizontal.vue?vue&type=template&id=762e2873&scoped=true&"
import script from "./ProductListCarouselCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./ProductListCarouselCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ProductListCarouselCardHorizontal.vue?vue&type=style&index=0&id=762e2873&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762e2873",
  null
  
)

export default component.exports